import { HttpMethod } from '@nu-art/thunderstorm-shared';
/**
 * The HTTP path of the `agent-query` endpoint for a given `dbKey`.
 */
export const agentQueryApiPath = (dbKey) => `v1/${dbKey}/agent-query`;
/**
 * Build the `ApiDef` for the `agent-query` endpoint of the given `dbKey`.
 *
 * Mirrors the `query` endpoint's HTTP shape (POST, 60s timeout) and is registered
 * by `addOrgPermissionsBE` for every wrapped DB module.
 */
export const agentQueryApiDef = (dbKey) => ({
    method: HttpMethod.POST,
    path: agentQueryApiPath(dbKey),
    timeout: 60000,
});
//# sourceMappingURL=agent-query.js.map